// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { ToastPlugin } from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios';
import MultiselectDefault from '@/components/common/MultiselectDefault'
import '@/assets/css/multiselect-bs4.css'
import store from './store'

//import helper here incase need helper
import helper from './helper';

import * as firebase from "firebase";

import VueFormulate from '@braid/vue-formulate'
Vue.use(VueFormulate)

//Vue.component('my-component-name', MyComponent)
// todo
// cssVars()

// ======= ENVIRONMENT SETUP


// === LOCALHOST
const BASE_PATH = "https://api.dev-aws.pgindonesia.com/";
const BASE_FILE_PATH = "https://file.dev-aws.pgindonesia.com";
const BASE_FILE_PATH_AWS = "https://pugindo-pgi-dev.s3.ap-southeast-3.amazonaws.com/";


// === DEV API1 -- NOT USED ANYMORE, USE DEV2
// const BASE_PATH = "https://api.dev1.pgindonesia.com/"
// const BASE_FILE_PATH = "https://dev.earth.pgindonesia.com"

// === DEV API2
// const BASE_PATH = "https://api.dev2-emas.pgindonesia.com/";
// const BASE_FILE_PATH = "https://file.dev2-emas.pgindonesia.com";

// === DEV API2
// const BASE_PATH = "https://cadangan-pugindo-fire.pugindo.com/"
// const BASE_FILE_PATH = "https://cadangan-pugindo-earth.pugindo.com"

// const BASE_PATH = "https://cadangan-sgp-fire.pugindo.com/"
// const BASE_FILE_PATH = "https://cadangan-sgp-earth.pugindo.com"

// === PRODUCTION JABODETABEK-BALI
// const BASE_PATH = "https://fire.pgindonesia.com/"
// const BASE_FILE_PATH = "https://earth.pgindonesia.com"
// const BASE_FILE_PATH_AWS = "https://pugindo-pgi.s3.ap-southeast-3.amazonaws.com/";

// === PRODUCTION SEMARANG
// const BASE_PATH = "https://a.sgp.fire.pgindonesia.com/"
// const BASE_FILE_PATH = "https://sgp.earth.pgindonesia.com"
// const BASE_FILE_PATH_AWS = "https://pugindo-sgp.s3.ap-southeast-3.amazonaws.com/";

// === CADANGAN
// const BASE_PATH = "https://cadangan.fire.pugindo.com/"
// const BASE_FILE_PATH = "https://cadangan.earth.pugindo.com"

// === EMAS
// const BASE_PATH = "https://a.emas.fire.pgindonesia.com/"
// const BASE_FILE_PATH = "https://emas.earth.pgindonesia.com"

// === COMPANY NAME
const companyName = 'Pusat Gadai Indonesia'
const companyId = 'PGI'
const logoPath = BASE_FILE_PATH + '/LOGO_PROGRAM/logo.png'
const bgLoginPath = '/img/brand/pgi_bg.jpg'

// const companyName = 'Sinar Gadai Pratama'
// const companyId = 'SGP'
// const logoPath = BASE_FILE_PATH + '/LOGO_PROGRAM/sgp_logo.png'
// const bgLoginPath = '/img/brand/pgi_bg.jpg'

// const companyName = 'Pusat Gadai Emas Indonesia'
// const logoPath = '/img/brand/emas_logo.png'
// const bgLoginPath = '/img/brand/pgi_bg.jpg'

// ======= END ENVIRONMENT SETUP

axios.defaults.baseURL = BASE_PATH
axios.defaults.timeout = 120000
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = localStorage.getItem("token") || ""

// Plugins
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
const vm = new Vue();

// Handle Network Error
let networkErrorShown = false
const handleNetworkError = () => {
    if (!networkErrorShown) {
        networkErrorShown = true

        vm.$bvToast.toast(
            'Tidak dapat terhubung ke server. Periksa koneksi internet Anda.',
            {
                title: 'Koneksi Gagal',
                variant: 'danger',
                solid: true,
                autoHideDelay: 4000,
            }
        )

        setTimeout(() => {
            networkErrorShown = false
        }, 1000)
    }
}

// Interceptors for 401 responses (unauthorized)
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response && error.response.status == 401) {

        let fcmToken = localStorage.getItem("fcmToken")

        if (fcmToken != null) {

            // Request logout
            let payload = new FormData()
            payload.append("token", fcmToken)
            axios.post("/user/logout", payload)
            firebase.messaging().deleteToken(fcmToken)
        }

        axios.defaults.headers.common['Authorization'] = ""
        var version = localStorage.getItem("version")
        localStorage.clear()
        sessionStorage.clear();
        localStorage.setItem("version", version)

        router.push("/login")

    } else if (error.message == 'Network Error') {
        handleNetworkError();
    }

    return Promise.reject(error)

})

/// ===

// // Interceptors for 500 responses (unauthorized)
// axios.interceptors.response.use(function(response) {
//     console.log(response)
//     return response
// }, function (error) {
//     if(error.response && error.response.status == 500) {

//         console.log("500")
//         let fcmToken = localStorage.getItem("fcmToken")

//         if(fcmToken != null) {

//             // Request logout
//             let payload = new FormData()
//             payload.append("token", fcmToken)
//             axios.post("/user/logout", payload)
//             firebase.messaging().deleteToken(fcmToken)
//         }

//         axios.defaults.headers.common['Authorization'] = ""
//         var version = localStorage.getItem("version")
//         localStorage.clear()
//         localStorage.setItem("version", version)

//         router.push("/login")

//     }

//     return Promise.reject(error)

// })
// /// ===


/// ==== SETUP FIREBASE
if (firebase.messaging.isSupported()) {

    //https://medium.com/@n11sh1/how-to-build-pwa-w-vue-cli-3-service-workers-add-to-home-screen-push-notifications-b519c49e142d
    const firebaseConfig = {
        apiKey: "AIzaSyCeCCY0eWnLguB3rGR_rT6Vl5Oh1Kp3ja8",
        authDomain: "pusat-gadai-indonesia-ab0d9.firebaseapp.com",
        databaseURL: "https://pusat-gadai-indonesia-ab0d9.firebaseio.com",
        projectId: "pusat-gadai-indonesia-ab0d9",
        storageBucket: "pusat-gadai-indonesia-ab0d9.appspot.com",
        messagingSenderId: "449052199748",
        appId: "1:449052199748:web:65069d087f3537004a2511",
        measurementId: "G-PEBD1EGZMY"
    }

    if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfig)
    }

    const messaging = firebase.messaging()
    messaging.usePublicVapidKey("BNb_DBKszca9ueXR2-YVGU0O5xZhkUvsfSnrfjovDnQpnEJCFpxq6W7_bycuQc0zFPpxY8wyiLoDhI0RT4Ta4kQ")

    navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
        messaging.useServiceWorker(registration)
    })
        .catch(err => {
            console.log(err)
        })

}

Vue.component('multiselect', MultiselectDefault)

Vue.prototype.$axios = axios
Vue.prototype.$helper = helper
Vue.prototype.$baseFilePath = BASE_FILE_PATH
Vue.prototype.$baseFilePathAws = BASE_FILE_PATH_AWS
Vue.prototype.$firebase = firebase
Vue.prototype.$footerName = companyName
Vue.prototype.$companyId = companyId
Vue.prototype.$logoPath = logoPath
Vue.prototype.$bgLoginPath = bgLoginPath


/// GLOBAL COMPONENTS
/// Base components
const requireComponent = require.context('./globals', false, /[A-Z]\w+\.(vue|js)$/)

requireComponent.keys().forEach(fileName => {

    const componentConfig = requireComponent(fileName)
    let compName = fileName.includes("Loading") ? "LoadingWidget" : "ModalConfirm"

    Vue.component(compName, componentConfig.default || componentConfig)

})

// HANDLE CHUNK ERROR
const CHUNK_RELOAD_GUARD_KEY = 'chunk_reload_guard'

function isChunkLoadError(error) {
    if (!error) return false

    const messageSource =
        (typeof error === 'string' && error) ||
        error.message ||
        (error.toString && error.toString())

    const message = String(messageSource || '').toLowerCase()

    return (
        message.includes('chunkloaderror') ||
        message.includes('loading chunk') ||
        message.includes('failed to fetch dynamically imported module') ||
        message.includes('importing a module script failed')
    )
}

function reloadOnceForChunkError() {
    try {
        const hasReloaded =
            sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === '1'

        if (hasReloaded) return

        sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, '1')
    } catch (e) {}

    window.location.reload()
}

function setupChunkErrorHandler(routerInstance) {
    routerInstance.onError((error) => {
        if (isChunkLoadError(error)) {
            reloadOnceForChunkError()
        }
    })

    routerInstance.afterEach(() => {
        try {
            sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY)
        } catch (e) {}
    })

    window.addEventListener('error', (event) => {
        const target = event && event.target
        const source = target && target.src

        if (
            (source && source.includes('/js/chunk-')) ||
            isChunkLoadError(
                (event && event.error) || (event && event.message)
            )
        ) {
            reloadOnceForChunkError()
        }
    })

    window.addEventListener('unhandledrejection', (event) => {
        if (isChunkLoadError(event && event.reason)) {
            reloadOnceForChunkError()
        }
    })
}

setupChunkErrorHandler(router)

document.addEventListener('wheel', (e) => {
    const el = document.activeElement
    if (el instanceof HTMLInputElement && el.type === 'number' && el === e.target) {
        el.blur()
    }
}, { passive: true })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})
